export const ADD_NEW_PROJECT = 'ADD_NEW_PROJECT'
export const ADD_NEW_SUBMISSION = 'ADD_NEW_SUBMISSION'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const EDIT_PROFILE = 'EDIT_PROFILE'
export const EDIT_SUBMISSION = 'EDIT_SUBMISSION'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
